import { graphql, readInlineData } from 'react-relay';
import currencies from 'dibs-currency-helpers/exports/currencies.ts';
import { type PrerenderedCheckoutParams } from '../prerender/prerenderedCheckoutStore.ts';
import { type getCheckoutUrl_item$key } from './__generated__/getCheckoutUrl_item.graphql.ts';

const itemFragment = graphql`
    fragment getCheckoutUrl_item on Item @inline {
        serviceId
        defaultSkuId
    }
`;

export type GetCheckoutUrlParams = {
    item: getCheckoutUrl_item$key | null | undefined;
} & PrerenderedCheckoutParams;

export const getCheckoutUrl = ({ item: itemRef, ...otherParams }: GetCheckoutUrlParams): string => {
    const item = readInlineData(itemFragment, itemRef);
    const { serviceId: itemId, defaultSkuId } = item || {};
    if (!otherParams.skuId && defaultSkuId) {
        otherParams.skuId = defaultSkuId;
    }
    const fakeBase = 'https://base'; // window.location.origin can't be used on ssr
    const url = new URL(`/checkout/id-${itemId}/`, fakeBase);

    let abtests;
    const currentAbtestsParam = new URLSearchParams(window.location.search).get('abtests');
    if (currentAbtestsParam) {
        abtests = currentAbtestsParam;
    }

    for (const [key, value] of Object.entries(otherParams)) {
        if (key === 'offerCurrency' && !currencies.includes(String(value))) {
            continue;
        }
        if (value) {
            url.searchParams.set(key, String(value));
        }
    }

    if (abtests) {
        url.searchParams.set('abtests', abtests);
    }

    return url.href.replace(fakeBase, '');
};
